import React from "react";
import { MouseEvent } from "react";
import { Icon } from "../../Common/Icons/LucideIcons";
import { LegendControl } from "../__styles__/FullPageMap";
import { LegendControlContainer } from "../__styles__/FullPageMap";
import { MapToolLabel } from "./MapToolLabel";

interface LegendControlProps {
  activeFloodLayerName?: string;
  handleLayersToggle?: (evt: MouseEvent | KeyboardEvent) => void;
}

export const LegendControlTool = ({
  activeFloodLayerName,
  handleLayersToggle,
}: LegendControlProps) => {
  return (
    <LegendControlContainer>
      {activeFloodLayerName && (
        <MapToolLabel
          label={activeFloodLayerName}
          permanent
          onClick={handleLayersToggle}
        />
      )}
      <LegendControl
        data-testid="legendControl"
        styleVariant="outlineLight"
        onClick={handleLayersToggle}
        aria-label="Toggle Map Layers panel"
      >
        <Icon iconName="layers" color="contentPrimary" size={16} />
      </LegendControl>
    </LegendControlContainer>
  );
};
